








import Vue from 'vue';
import { recognition } from 'mycorems-app-accounts';
import AgencyDashboard from '@/account/agency/AgencyDashboard.vue';
import ClientDashboard from '@/account/client/ClientDashboard.vue';
import CompanyDashboard from '@/account/company/CompanyDashboard.vue';

export default Vue.extend({
  data() {
    return {
      accountId: recognition.getAccountId(),
    };
  },
  computed: {
    isAgency(): boolean {
      return recognition.isAgency();
    },
    isClient(): boolean {
      return recognition.isClient();
    },
    isCompany() {
      return recognition.isCompany();
    },
  },
  components: {
    AgencyDashboard,
    ClientDashboard,
    CompanyDashboard,
  },
});
